"use client";
import { PreventScroll } from "@/components/PreventScroll";
import { formatPrice } from "@/lib/formatPrice";
import { type ReactNode, useEffect } from "react";
import usePortal from "react-cool-portal";
import { CrossIcon } from "ui/iconsN";

const HUBSPOT_PORTAL_ID = "144886640";
const HUBSPOT_FORM_ID = "9e370a1c-9bca-472b-971b-10d622b12299";

type Props = {
  heading?: string;
  title?: string;
  price?: number | null;
  className?: string;
  openOnParam?: string;
  children: ReactNode;
};
export const QuoteRequestFIT = ({
  heading = "Demander mon devis",
  title,
  price,
  className,
  openOnParam,
  children,
}: Props) => {
  const { Portal, show, hide } = usePortal({
    defaultShow: false,
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: only on mount, `show` isn't stable
  useEffect(() => {
    if (openOnParam && new URLSearchParams(window.location.search).get(openOnParam) === "1") {
      show();
    }
  }, []);

  return (
    <>
      <div onClick={show} className={className}>
        {children}
      </div>
      <Portal>
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-tx-1/40 md:items-center md:p-6">
          <PreventScroll />
          <div className="flex max-h-[calc(100dvh-24px)] w-full max-w-2xl flex-col overflow-hidden rounded-t-xl bg-white md:max-h-[calc(100dvh-48px)] md:rounded-xl">
            <div className="relative shrink-0 bg-fit-1 px-4 py-4 text-white md:px-6">
              <p className="pr-8 font-serif font-medium text-xl">{heading}</p>
              {(title || price) && (
                <p className="mt-1 pr-8 text-sm text-white/70">
                  {title}
                  {title && price ? " — " : ""}
                  {price ? `À partir de ${formatPrice(price)}` : ""}
                </p>
              )}
              <button
                type="button"
                onClick={hide}
                className="absolute top-4 right-4 flex size-6 cursor-pointer items-center justify-center rounded-sm bg-white/10 hover:bg-white/20"
              >
                <CrossIcon className="size-3 stroke-white" />
              </button>
            </div>
            <div className="grow overflow-y-auto">
              <script src={`https://js-eu1.hsforms.net/forms/embed/${HUBSPOT_PORTAL_ID}.js`} defer async />
              <div
                className="hs-form-frame [&_iframe]:block"
                data-region="eu1"
                data-form-id={HUBSPOT_FORM_ID}
                data-portal-id={HUBSPOT_PORTAL_ID}
              />
            </div>
          </div>
        </div>
      </Portal>
    </>
  );
};
